(() => {
  const root = document.querySelector('[data-cm26]');
  if (!root || root.dataset.analyticsReady === 'true') return;
  root.dataset.analyticsReady = 'true';
  const emit = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, campaign_id: 'coder_month_2026', campaign_brand: 'logitech', ...detail });
  };
  emit('bt_campaign_view', { source_component: 'landing' });
  root.addEventListener('click', (event) => {
    const register = event.target.closest('[data-cm-register]');
    if (register) emit('bt_campaign_register_click', { source_component: register.dataset.sourceComponent || 'landing' });
    const product = event.target.closest('[data-cm-product]');
    if (product) emit('bt_campaign_product_click', { product_sku: product.dataset.productSku || '', source_component: product.dataset.sourceComponent || 'product_grid' });
    const gift = event.target.closest('[data-cm-gift-product]');
    if (gift) emit('bt_campaign_gift_product_click', { product_sku: gift.dataset.productSku || '', source_component: 'h390_gift' });
  });
  const gift = root.querySelector('[data-cm-gift]');
  if (gift && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      emit('bt_campaign_gift_view', { source_component: 'h390_gift' });
      observer.disconnect();
    }, { threshold: .35 });
    observer.observe(gift);
  }
})();
